import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import StockInListController from '../stockinlist/StockInListController'
import StockInController from '../stockin/StockInController'
import StockInItemFooterStyle from './css/StockInItemFooterStyle'
import { appContext } from '../../../App'
import { stockInItemControllerContext } from './StockInItemController'
import { longDateAndTimeString } from '../../utilities/utilities'

function StockInItemFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockInItemController = useContext(stockInItemControllerContext)
  const { stockInItem, saveStockIn, deleteStockIn, restoreStockIn, getStockInByID } = stockInItemController
  const [successMessage, setSuccessMessage] = useState(false)

  const showMessageBoxSINotFound = () => {
    const onClick = () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      setContent(<StockInListController />)
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width='25'
        height='20'
        header='SI Not Found'
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>The StockIn file/record no longer exist.</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickEdit = async (e) => {
    const si = await getStockInByID(app, stockInItem._id) // Fetch the updated data from the database directly

    const showMessageBox = () => {
      let message_box_content = null
      const last_modified_by = si.log.last_modified_by.name
      const last_modified = longDateAndTimeString(new Date(si.date_time_modified))

      const onClick = async (button) => {
        if (button === 'Yes') {
          // Will restore products item inventory here only if the item status is Posted
          // The logic is set on the API backend. It will not restore On Process stockin.
          await restoreStockIn(app, si._id)
          setContent(<StockInController stockInItem={si}/>)
        }
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      // Determine stockin status first to set proper messagebox content
      switch(si.status) {
        case 'On Process':
          message_box_content =
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>This item is marked as On Process.</div>
                <div>It was last modified by <i>{last_modified_by}</i> on <i>{last_modified}</i></div>
                <div>Proceed only if you are certain it is no longer on process.</div>
                <br />
                <div>Are you sure you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        break
        default: // Posted
          message_box_content =
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Editing posted stockin will restore back all the item listed in here.&nbsp;
                Negative result will round-off/reset to 0 inventory on the particular item.</div>
                <br/>
                <div>Are you sure you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => { onClick('No')}} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => { onClick('Yes')}} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
      }

      ReactDOM.render(
        <ModalWindow id='mw-parent' height='30' width='40' header='Edit Stockin' footer={null}>
          {message_box_content}
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showMessageBoxSINotFound = () => {
      const onClick = async () => {
        setContent(<StockInListController />)
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow id='mw-parent' height='20' width='25' header='SI Not Found' footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The StockIn file/record no longer exist.</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (si) { // If item still exist
      if (si.status === 'Unposted') setContent(<StockInController stockInItem={si}/>)
      else showMessageBox()
    } else showMessageBoxSINotFound()
  }

  const onClickDelete = async (e) => {
    let message_box_content = null

    // Determine stockin status and set proper message on messagebox window
    switch(stockInItem.status) {
      case 'Unposted':
      case 'Inactive':
        message_box_content = 
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>You are about to delete these post.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No')}} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes')}} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
      break
      default: // Posted
        message_box_content =
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Deleting this post will pull-out all the items listed in here from the inventory.&nbsp;
              Negative result will round-off/reset to 0 inventory on the particular item.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No')}} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes')}} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
    }

    const onClick = async (button) => {
      if (button === 'Yes') {
        const status = await deleteStockIn(app, stockInItem._id)

        if (status) {
          setSuccessMessage('Deleted successfully! Loading StockIn List, please wait...')
          setTimeout(() => {
            setSuccessMessage('')
            setContent(<StockInListController />)
          }, 1000)
        } else {
          setSuccessMessage('Something went wrong! Data not deleted.')
          setTimeout(() => {
            setSuccessMessage('')
            setContent(<StockInListController />)
          }, 1000)
        }
      }

      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    ReactDOM.render (
      <ModalWindow id='mw-parent' height='30' width='40' header='Delete Stock-In Record' footer={null}>
        {message_box_content}
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickPost = async (e) => {
    const stock_in = getStockInByID(app, stockInItem._id)

    const showMessageBox = async () => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          stockInItem.status = 'Posted'
          saveStockIn(app, stockInItem)
          .then(si => {
            if (si.status) {
              setSuccessMessage('Posted successfully! Loading StockIn List, please wait...')
              setTimeout(() => {
                setSuccessMessage('')
                setContent(<StockInListController />)
              }, 1000)
            }
          })
        }

        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='30'
          width='35'
          header='Post'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>You are about to post these stocks to the inventory.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => onClick('No')} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => onClick('Yes')} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (stock_in) showMessageBox()
    else showMessageBoxSINotFound()
  }

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.stockin_fc

  return (
    <ContentFooter>
      <div id="stock-in-item-footer-container">
        <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
        <div className='translist-button-container'>
          <button className="pospro-action-btn"
            id="stockin-translist-button"
            type="button"
            onClick={() => setContent(<StockInListController />)}>
            <FontAwesomeIcon icon='undo-alt'/>&nbsp;Back to Stockin's List
          </button>
          <button className="pospro-action-btn"
            style={{display: ((stockInItem.status === 'Auto-Posted') || (!userHaveFC)) ? 'none' : 'block'}}
            id="stockin-item-edit-button"
            type="button"
            onClick={onClickEdit}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Edit
          </button>
          <button className="pospro-action-btn"
            style={{display: (((stockInItem.status === 'Auto-Posted') || (stockInItem.status === 'On Process')) || (!userHaveFC)) ? 'none' : 'block'}}
            id="stockin-item-delete-btn"
            type="button"
            onClick={onClickDelete}>
            <FontAwesomeIcon icon='times'/>&nbsp;Delete
          </button>
          <button className="pospro-action-btn"
            id="stockin-item-print-button"
            type="button"
            onClick={() => window.print()}>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
          <button className="pospro-action-btn"
            style={{display: ((stockInItem.status === 'Unposted') && (userHaveFC)) ? 'block' : 'none'}}
            id="stockin-item-post-button"
            type="button"
            onClick={onClickPost}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Post
          </button>
          <button className="pospro-action-btn"
            id="stockin-addnew-button"
            type="button"
            onClick={() => setContent(<StockInController />)}>
            <FontAwesomeIcon icon='plus'/>&nbsp;Add New
          </button>
        </div>
      </div>
      <StockInItemFooterStyle signed_in={app.client.signed_in} />
    </ContentFooter>
  )
}

export default React.memo(StockInItemFooter)